/**
 * @author Jorge Casas
 * @creationDate 23/04/2024
 */

const monthMap = {
    Jan: '01',
    Feb: '02',
    Mar: '03',
    Apr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Aug: '08',
    Sep: '09',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  };
/**
 * @function formatDate
 *
 * @description Format date to dd/mm/yyyy
 *
 * @param {String} date
 * @returns {String}
 * @example
 * formatDate('2024-04-23') // 23/04/2024
 */
export const formatDate = (_d) => {
  if (!_d) return '-';

  const date = _d instanceof Date ? _d : new Date(_d);
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  if (_d.toString().includes('T')) {
    const [fullDate] = _d.toString().split('T');
    const [year, month, day] = fullDate.split('-');
    return `${day}/${month}/${year}`;
  }

  if (_d.toString().includes(' ')) {
    const [, monthName] = _d.toString().split(' ');
    month = monthMap[monthName];
  }

  return `${day}/${month}/${year}`;
};



// WEBPACK FOOTER //
// src/utils/additional-functions/formatted-date.js